/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { token } from '@atlaskit/tokens';
import imgSVG from './assets/capacity-app-skeleton.tpl.svg';
import embedImgSVG from './assets/capacity-embed-app-skeleton.tpl.svg';
import noHeaderImgSVG from './assets/capacity-no-header-skeleton.tpl.svg';

export const CapacitySkeleton = () => (
	<AppSkeletonImage src={imgSVG} css={styles.compensateTemplateBorder} />
);

export const CapacityEmbedSkeleton = () => (
	<AppSkeletonImage src={embedImgSVG} css={styles.compensateTemplateBorder} />
);

export const CapacityNoHeaderSkeleton = () => (
	<AppSkeletonImage src={noHeaderImgSVG} css={[styles.noBorder, styles.compensateTemplateBorder]} />
);

export const EntryPointCapacitySkeleton = () => (
	<div css={styles.entryPointStyles}>
		<CapacitySkeleton />
	</div>
);

const styles = cssMap({
	// AppSkeletonImage has borderLeftWidth: 40px which messes up skeleton alignment with the aftercoming content.
	compensateTemplateBorder: {
		borderLeftWidth: 0,
		borderRightWidth: 0,
		'@media (min--moz-device-pixel-ratio: 2)': {
			borderLeftWidth: 0,
			borderRightWidth: 0,
		},
	},
	// Keep in sync with the wrapper in JiraCapacitySpaApp.
	entryPointStyles: {
		paddingBlock: token('space.300'),
		paddingInlineStart: token('space.400'),
		flexGrow: 1,
		overflow: 'hidden',
	},
	noBorder: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&&': {
			border: 'none',
		},
	},
});
